import get from 'lodash/get'
import capitalize from '@fielded/shared-ui/src/utils/capitalize'

export const SHIPMENT_DELIVERY_DISCREPANCY_FLAGS = {
  LOCATION_VERIFICATION: 'Location verification',
  OTP_VALIDATION: 'OTP validation',
  QUANTITY_MISMATCH: 'Discrepancies in quantity delivered'
}

// Delivery distance in km
export const MAXIMUM_DELIVERY_RADIUS_KM = 2

// GPS accuracy threshold in meters - warn driver if accuracy is worse than this
export const GPS_ACCURACY_WARN_THRESHOLD_M = 500

export const transformShipmentGPSAndOTPFailedOptions = (gpsReasons, otpReasons) => {
  const gpsFailedOptions = []
  const otpFailedOptions = []

  // we delete reasons that are fired silently by the system
  // (not driver-selectable) so they aren't shown in the reason picker
  delete gpsReasons.permission_denied
  delete gpsReasons.location_coordinates_missing
  for (let reason in gpsReasons) {
    gpsFailedOptions.push({
      label: gpsReasons[reason],
      value: gpsReasons[reason] // we send the object value to the API
    })
  }

  for (let reason in otpReasons) {
    otpFailedOptions.push({
      label: otpReasons[reason],
      value: reason // we send the object key to the API
    })
  }

  return { gpsFailedOptions, otpFailedOptions }
}

export const getPSMDriverDeliveryTitle = (delivery) => {
  let title = ''
  let location = ''
  const id = get(delivery, 'destination.id')

  if (!id) {
    return { title, location }
  }

  const name = id.split(':sdp:')[1]
  if (!name) {
    return { title, location }
  }

  location = capitalize(name.replace(/-/g, ' '))
  title = `Distribution to ${location}`

  return { title, location }
}

export const isWithinDeliveryRadius = (distance) => {
  const formattedDistance = Math.ceil(distance)
  return formattedDistance <= MAXIMUM_DELIVERY_RADIUS_KM
}
